// extracted by mini-css-extract-plugin
module.exports = {"wrapperMain":"ShortcutsMenu_wrapperMain__2u-tv","wrapperInner":"ShortcutsMenu_wrapperInner__2Kr7h"};